<template>
  <v-menu
    ref="dateMenu"
    v-model="menu"
    :close-on-content-click="false"
    :open-on-click="!readonly"
    transition="scale-transition"
    min-width="auto"
  >
    <template v-slot:activator="{ props }">
      <v-text-field
        v-model="formattedDate"
        :required="required"
        :label="label"
        :prepend-icon="prependIcon"
        :disabled="disabled"
        :readonly="readonly"
        v-bind="props"
        :rules="rules"
        :variant="variant"
        :density="density"
        @update:model-value="changeSelectedDateFromText"
        @focus="updateTextFieldFocus(true)"
        @blur="updateTextFieldFocus(false)"
        @keyup.enter="updateTextFieldFocus(false)"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"
      hide-header
      :color="color"
      :min="min"
      :max="max"
      :disabled="disabled"
      :readonly="readonly"
      @update:model-value="changeSelectedDate"
    >
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" color="primary" @click="menu = false"
          >Cancel</v-btn
        >
        <v-btn variant="text" color="primary" @click="saveDate">OK</v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>

<script>
import formatter from "@/utils/formatter"
export default {
  name: "brk-date-picker",
  emits: ["input"],
  props: {
    value: String,
    label: String,
    rules: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: "mdi-calendar-check"
    },
    color: {
      type: String,
      default: undefined
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: undefined
    },
    density: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      menu: false,
      selectedDate: this.value,
      dateUpdatedFromText: false,
      formattedDate: null
    }
  },
  watch: {
    value(val) {
      this.selectedDate = val
      this.formattedDate = this.formatModelValue(this.selectedDate)
      this.menu = false
      this.dateUpdatedFromText = false
    }
  },
  methods: {
    changeSelectedDateFromText(newDateString) {
      this.formattedDate = newDateString
      const possibleDate = Date.parse(newDateString)
      this.dateUpdatedFromText = !isNaN(possibleDate)
      if (this.dateUpdatedFromText) {
        this.selectedDate = new Date(possibleDate)
      }
    },
    formatModelValue(modelValue) {
      if (modelValue instanceof Date) {
        return formatter().formatDate(modelValue)
      }
      return modelValue
    },
    changeSelectedDate(newDate) {
      this.selectedDate = newDate
      this.dateUpdatedFromText = false
    },
    updateTextFieldFocus(isFocused) {
      if (!isFocused && this.dateUpdatedFromText) {
        this.saveDate()
      }
      this.dateUpdatedFromText = false
    },
    saveDate() {
      this.menu = false
      this.dateUpdatedFromText = false
      this.formattedDate = this.formatModelValue(this.selectedDate)
      this.$emit("input", this.selectedDate)
      this.$refs.dateMenu?.save?.(this.selectedDate)
    }
  }
}
</script>
